import { Tooltip } from "antd";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Timer from "react-compound-timer";
import { processAudio } from "../../api/processAudio";
import rightArrowIcon from "../../assets/icon/rightArrowIcon.svg";
import InfoAudio from "../../components/infoaudio/infoAudio";
import { getStudentData } from "../../helper/localStorage.js";
import submitQues from "../../helper/submitQues.js";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import { RecorderContext } from "../../store/recorderStore";
import AudioRecorder from "../audioRecorder/audioRecorder";

export default function TestFooterAudio({ question, questions, index }) {
  const [isRecording, setIsRecording] = useState(false);
  const [isAudioStarted, setIsAudioStarted] = useState(false);
  //this variable decide weather its time to move forward or not
  const [isDisableNext, setIsDisableNext] = useState(true);

  const [isAllowedRec, setIsAllowedRec] = useState(true);
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC, dispatchHelper } = HelperContext();
  const { recorderC, dispatchRecorder } = RecorderContext();

  const [startTime, setStartTime] = useState();
  const [myBlob, setMyBlob] = useState();

  //user can only pause the audio only after one second
  const [isOneSecDone, setIsOneSecDone] = useState(false);
  // user can only pasuse after 5 second is done (taking in account for 1sec delay in css)
  const [isBufferTimeDone, setIsBufferTimeDone] = useState(false);
  // delay for text below record btn
  const [switchText, setSwitchText] = useState(false);

  const timeoutRef = useRef(null);
  const startTimerRef = useRef(null);
  const stopTimerRef = useRef(null);

  console.log("processAudio", answerC);
  console.log("shuffeledImage testFooterAudio.jsx", helperC.shuffeledImage);

  useEffect(() => {
    if (helperC.isAudioEnded) {
      setIsAllowedRec(true);
      clearTimeout(timeoutRef.current);
    }
  }, [helperC.isAudioEnded]);

  useEffect(() => {
    const isReplay = question.replay !== "N";

    dispatchHelper({ type: "IS_REPLAY", payload: isReplay });
    dispatchHelper({ type: "IS_AUDIO_ENDED", payload: false });
    // dispatchAnswer({ type: "RESET_ANSWER" });
    setStartTime(moment());

    // this condition is running on audio replay N cases
    if (!isReplay && !helperC.isAudioEnded) {
      setIsAllowedRec(false);
      timeoutRef.current = setTimeout(() => {
        // just to start only the timer
        dispatchHelper({ type: "IS_AUDIO_ENDED", payload: true });
        dispatchHelper({ type: "IS_AUDIO_ENDED", payload: false });
      }, 30000);

      return () => {
        clearTimeout(timeoutRef.current);
      };
    }
  }, []);

  const startRecording = () => {
    setIsAudioStarted(true);
    setIsRecording(true);
    dispatchRecorder({ type: "RECORDER_STAT", payload: true });
    // startTimerRef.current.click();
    // const oneSecHold = setTimeout(() => {
    //   setIsOneSecDone(true);
    //   clearTimeout(oneSecHold);
    // }, 1000);

    // For 1 sec delay in css (timer starts with 1 sec delay while the actual recording has already begun)
    // setTimeout(() => {
    //   // setIsRecording(true);
    //   // startTimerRef.current.click();
    // }, 1000);

    const twoSecHold = setTimeout(() => {
      console.log("inside isBufferTimeDone timeout", isBufferTimeDone);
      setIsOneSecDone(true);
      setIsBufferTimeDone(true);
      clearTimeout(twoSecHold);
      // }, 2200);
    }, 5200);
  };

  useEffect(() => {
    // console.log("useEffect startTimerRef", startTimerRef);
    const switchTextTimer = setTimeout(() => {
      console.log("setTimeout startTimerRef", startTimerRef);
      setSwitchText(isAudioStarted);

      if (isAudioStarted) startTimerRef.current.click();

      clearTimeout(switchTextTimer);
    }, 1000);
  }, [isAudioStarted, startTimerRef]);

  const getTimeSpend = () => {
    return moment().diff(startTime);
  };

  const stopRecording = () => {
    localStorage.setItem("timeSpend", getTimeSpend());
    setIsRecording(false);
    dispatchRecorder({ type: "RECORDER_STAT", payload: false });
    stopTimerRef.current.click();
  };

  const localShuffeledImage = helperC.shuffeledImage;

  console.log("localShuffeledImage", localShuffeledImage);

  const processUserAudio = (recordedBlob) => {
    if (helperC.testType === "DEMO") {
      dispatchAnswer({ type: "IS_LOADING", payload: true });
      const dummyApiCall = setTimeout(() => {
        dispatchAnswer({ type: "IS_LOADING", payload: false });
        dispatchHelper({ type: "IS_NEXT_QUES", payload: true });
        localStorage.removeItem("timeSpend");
        clearTimeout(dummyApiCall);
      }, 500);
    } else {
      console.log(
        "shuffeledImage testFooterAudio.jsx inside processUserAudio",
        helperC.shuffeledImage
      );
      console.log(
        "shuffeledImage testFooterAudio.jsx localShuffeledImage inside processUserAudio",
        localShuffeledImage
      );
      processAudio(
        question,
        getStudentData(),
        recordedBlob,
        dispatchAnswer,
        dispatchHelper,
        helperC.testType,
        // helperC.shuffeledImage
        localShuffeledImage
      );
    }
  };

  const onStop = (recordedBlob) => {
    //hit api and get data from backend
    setMyBlob(recordedBlob);
    processUserAudio(recordedBlob);
    setIsDisableNext(false);
  };

  // auto hitting the api if user automatically move to next question after timer ends
  const hitApiWithEmptyBlob = () => {
    // same as not hitting to the questions

    localStorage.setItem("timeSpend", getTimeSpend());
    setIsDisableNext(false);

    const recordedBlob = {
      blob: new Blob([], { type: "audio/wav" }),
      startTime: 1,
      stopTime: 300,
    };
    processUserAudio(recordedBlob);
  };

  // very important next or submit logic
  useEffect(() => {
    if (helperC.isNextQues) {
      // condition for moving to next text
      if (index < questions.length - 1) {
        if (isRecording) {
          dispatchHelper({ type: "IS_NEXT_QUES", payload: false }); // for preventing twice next move
          stopRecording();
        } else if (!isRecording && !isAudioStarted && getTimeSpend() > 500) {
          // for automatically hitting api at timer end
          dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
          hitApiWithEmptyBlob();
        } else {
          dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
          handleNext(questions[index + 1]);
        }
      }
      // condition for submitting the test
      else {
        if (isRecording) {
          dispatchHelper({ type: "IS_NEXT_QUES", payload: false }); // for preventing twice next move
          stopRecording();
        } else if (!isRecording && !isAudioStarted && getTimeSpend() > 500) {
          // for automatically hitting api at timer end
          dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
          hitApiWithEmptyBlob();
        } else {
          dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
          handleSubmit();
        }
      }
    }
  }, [helperC.isNextQues]);

  const handleNext = (nextTest) => {
    setIsRecording(false);
    dispatchRecorder({ type: "RECORDER_STAT", payload: false });
    dispatchHelper({
      type: "RUNNING_QUES_ID",
      payload: nextTest.id,
    });
  };

  console.log("helperC.testType", helperC.testType);
  console.log("question", question);
  console.log("isAudioStarted, switchText", isAudioStarted, switchText);

  const handleSubmit = () => {
    const isListenSpeakSeries =
      question["test_format"] === "listen_speak_series";
    setIsRecording(false);
    dispatchRecorder({ type: "RECORDER_STAT", payload: false });
    const answerRes = [...answerC.answers];
    if (!!helperC.testType) {
      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: "submitted",
      });
    } else {
      submitQues(
        dispatchAnswer,
        dispatchHelper,
        null, //answer
        null, //time spend on question
        question,
        null, //prev Answer
        answerRes, // answer audio
        null, // testFormat
        questions,
        helperC.testType,
        //additional argument to block addtestresult api
        isListenSpeakSeries // listen_speak_series
      );
    }
  };

  const handleButtonClick = () => {
    if (isRecording || isDisableNext) {
      return undefined;
    } else if (index < questions.length - 1) {
      handleNext(questions[index + 1]);
    } else {
      handleSubmit();
    }
  };

  const handleFormatTimer = (value) => {
    let myVal = value.toString().length;
    if (myVal <= 1) return `0${value}`;
    else {
      return value;
    }
  };

  return (
    <div className="test-footer">
      <div className="test-footer__one" color="#ffc700">
        <InfoAudio question={question} />
      </div>

      <div className="test-footer__two audio">
        <AudioRecorder
          isAllowedRec={isAllowedRec}
          isDisableNext={isDisableNext}
          startRecording={startRecording}
          stopRecording={stopRecording}
          onStop={onStop}
          isRecording={isRecording}
          isOneSecDone={isOneSecDone}
          isBufferTimeDone={isBufferTimeDone}
        />
        {/* {!isAudioStarted && ( */}
        {!switchText && (
          // <h3 className="content-below-audio">Press to record your answer.</h3>
          <h3 className="content-below-audio">
            {isAudioStarted ? "Loading..." : "Press to record your answer."}
          </h3>
        )}
        <Timer initialTime={0} startImmediately={false}>
          {({ start, stop }) => (
            <>
              <h3
                className="content-below-audio"
                // style={{ display: isAudioStarted ? "block" : "none" }}
                style={{ display: switchText ? "block" : "none" }}
              >
                <Timer.Minutes
                  formatValue={(value) => handleFormatTimer(value)}
                />{" "}
                :{" "}
                <Timer.Seconds
                  formatValue={(value) => handleFormatTimer(value)}
                />
              </h3>
              <div style={{ display: "none" }}>
                <button ref={startTimerRef} onClick={start}>
                  Start
                </button>
                <button ref={stopTimerRef} onClick={stop}>
                  Stop
                </button>
              </div>
            </>
          )}
        </Timer>
      </div>

      <div className="test-footer__three">
        <Tooltip title={isDisableNext && "Your answer is not recorded yet"}>
          <button
            onClick={handleButtonClick}
            className={`custom-btn footer ${isDisableNext ? "disable" : ""}`}
          >
            {index < questions.length - 1 ? "Next" : "Submit"}
            <img src={rightArrowIcon} alt="" />
          </button>
        </Tooltip>
      </div>
    </div>
  );
}
